var _rect, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTelegram = function SvgTelegram(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 25,
    fill: "none"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    y: 0.5,
    fill: "#40B3E0",
    rx: 4
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M19.333 6.303 16.908 18.53s-.339.848-1.272.44l-5.596-4.29-2.035-.983-3.426-1.154s-.525-.186-.576-.593.593-.627.593-.627L18.214 5.98s1.12-.492 1.12.322"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#D2E5F1",
    d: "M9.609 18.392s-.164-.015-.367-.66c-.204-.644-1.238-4.036-1.238-4.036l8.225-5.223s.475-.288.458 0c0 0 .084.051-.17.289-.254.237-6.461 5.816-6.461 5.816"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#B5CFE4",
    d: "m12.185 16.325-2.213 2.018s-.173.131-.363.05l.424-3.75"
  })));
};
export default SvgTelegram;